import {useState, useRef} from 'react'
import {TransitionGroup, CSSTransition} from 'react-transition-group'
import {useSafeEffect} from '@freckle/react-hooks'
import type {NotificationProps} from '@freckle/classroom/ts/common/components/notifications-wrapper/notification'
import {Notification} from '@freckle/classroom/ts/common/components/notifications-wrapper/notification'
import NotificationManager from '@freckle/classroom/ts/common/components/notifications-wrapper/notification-manager'
import {getNotification as getPaywallNotification} from '@freckle/classroom/ts/common/helpers/paywall-notification'
import type {PaywallNotificationTypeT} from '@freckle/classroom/ts/common/helpers/paywall-notification'
import {PaywallNotification} from './paywall-notification'

export function NotificationWrapper() {
  const [paywallNotification, setPaywallNotification] = useState<
    PaywallNotificationTypeT | null | undefined
  >(null)
  const [notificationProps, setNotificationProps] = useState<NotificationProps | null | undefined>(
    null,
  )

  const paywallNodeRef = useRef<HTMLDivElement>(null)
  const notificationNodeRef = useRef<HTMLDivElement>(null)

  const updateNotification = () => {
    const updatedPaywallNotification = getPaywallNotification()
    const notificationProps = NotificationManager.notificationProps

    setPaywallNotification(updatedPaywallNotification)
    setNotificationProps(notificationProps)
  }

  useSafeEffect(() => {
    window.addEventListener('update-notification', updateNotification, false)
    return () => {
      window.removeEventListener('update-notification', updateNotification, false)
    }
  }, [])

  return (
    <div className="notifications top-right">
      <TransitionGroup>
        {paywallNotification !== null && paywallNotification !== undefined ? (
          <CSSTransition
            key="paywall-notification"
            nodeRef={paywallNodeRef}
            classNames="notification" // eslint-disable-line i18next/no-literal-string
            timeout={300}
            unmountOnExit
          >
            <div ref={paywallNodeRef}>
              <PaywallNotification notification={paywallNotification} />
            </div>
          </CSSTransition>
        ) : null}
        {notificationProps !== null && notificationProps !== undefined ? (
          <CSSTransition
            key="general-notification"
            nodeRef={notificationNodeRef}
            classNames="notification" // eslint-disable-line i18next/no-literal-string
            timeout={300}
            unmountOnExit
          >
            <div ref={notificationNodeRef}>
              <Notification {...notificationProps} onClose={onCloseNotification} />
            </div>
          </CSSTransition>
        ) : null}
      </TransitionGroup>
    </div>
  )
}

function onCloseNotification() {
  NotificationManager.remove()
}
